<app-widget-option [categories]="['LAYERS']" [label]="'MAX_VALUES'">
  <div app-widget-option-content>
    <app-number [value]="widgetLayers.layer(current).maxValues" (sendValue)="receiveValue($event)" [color]="color" [min]="0" [max]="500" [step]="20"></app-number>
  </div>
</app-widget-option>